module.exports = __webpack_public_path__ + "img/Skirt-Front-B5-Da-Gc-Ha-Ic-Ja.7b7ca4e2.png";